import { motion } from "framer-motion";

/**
 * SplitText — Hero headlines split and animate character by character.
 * Now with improved word wrapping - keeps words together on lines.
 */
export default function SplitText({
  text = "",
  className = "",
  delay = 0,
  duration = 0.05,
  ease = [0.16, 1, 0.3, 1],
  staggerFrom = "first",
  as: Tag = "span",
  ...props
}) {
  const variants = {
    hidden: { opacity: 0, y: 30, filter: "blur(8px)" },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: Math.max(0.35, duration * 8), ease, delay },
    },
  };

  return (
    <motion.span
      className={`inline-block ${className}`}
      variants={variants}
      initial="hidden"
      animate="visible"
      aria-label={text}
      {...props}
    >
      {text}
    </motion.span>
  );
}

